import { Box, BoxProps, Breadcrumbs, Divider, Typography } from '@mui/material'
import Link from '../Link'
import { useNavigate } from 'react-router-dom'

interface BreadcrumbItem {
  label: string
  href?: string
}

export function BoxPage({
  children,
  title,
  breadcrumbs,
  showBackButton = false
}: BoxProps & { title: string; breadcrumbs?: BreadcrumbItem[]; showBackButton?: boolean }) {
  const navigate = useNavigate()

  return (
    <Box>
      <Box
        component={'div'}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 5
        }}
      >
        {showBackButton && <i className='tabler-chevron-left cursor-pointer' onClick={() => navigate(-1)}></i>}

        <Typography variant='h3'>{title}</Typography>

        <Divider orientation='vertical' flexItem />

        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumbs aria-label='breadcrumb' separator={<i className='tabler-chevron-right' />}>
            <Link color='inherit' href='/cms'>
              <i className='tabler-home' />
            </Link>
            {breadcrumbs.map((item, idx) =>
              item.href ? (
                <Link color='inherit' href={item.href} key={idx}>
                  {item.label}
                </Link>
              ) : (
                <Typography sx={{ color: 'text.primary' }} key={idx}>
                  {item.label}
                </Typography>
              )
            )}
          </Breadcrumbs>
        )}
      </Box>
      {children}
    </Box>
  )
}
